"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function saveSenderImageOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, viewStateConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, viewStateConfiguration = state.viewStateConfiguration;
                    return [4 /*yield*/, saveSenderImageOption(optionState.showSenderImageInListView, viewStateConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var saveSenderImageOption = legacy_1.action('saveSenderImageOption')(function saveSenderImageOption(isEnabled, viewStateConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    listViewBitFlagsUtil_1.setBit(!isEnabled, 8 /* HideSenderImage */);
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'ListViewBitFlags',
                                propertyType: 'Integer32',
                                propertyValue: "" + viewStateConfiguration.ListViewBitFlags,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
exports.onSenderImageToggle = legacy_1.select({
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function (isEnabled, state) {
    saveSenderImageOption(isEnabled, state.viewStateConfiguration);
});
//# sourceMappingURL=saveSenderImageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/actions/saveSenderImageOption.js
// module id = 5103
// module chunks = 2